import React from 'react';

interface ProfileSVGprops {
  color?: string; // Optional color prop
}

const ProfileSVG: React.FC<ProfileSVGprops> = ({ color = '#FAFAFA' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 6.00024V3.37573C12 2.75192 12 2.44002 11.8686 2.24834C11.7538 2.08087 11.576 1.96711 11.3758 1.93305C11.1467 1.89406 10.8635 2.02477 10.2971 2.28618L3.64426 5.35673C3.13913 5.58987 2.88656 5.70644 2.70158 5.88723C2.53804 6.04705 2.41321 6.24215 2.33663 6.45761C2.25 6.70133 2.25 6.9795 2.25 7.53583V11.2502M12.375 10.8752H12.3825M2.25 8.40024L2.25 13.3502C2.25 14.1903 2.25 14.6104 2.41349 14.9312C2.5573 15.2135 2.78677 15.4429 3.06901 15.5867C3.38988 15.7502 3.80992 15.7502 4.65 15.7502H13.35C14.1901 15.7502 14.6101 15.7502 14.931 15.5867C15.2132 15.4429 15.4427 15.2135 15.5865 14.9312C15.75 14.6104 15.75 14.1903 15.75 13.3502V8.40024C15.75 7.56016 15.75 7.14012 15.5865 6.81925C15.4427 6.53701 15.2132 6.30754 14.931 6.16373C14.6101 6.00024 14.1901 6.00024 13.35 6.00024L4.65 6.00024C3.80992 6.00024 3.38988 6.00024 3.06901 6.16373C2.78677 6.30754 2.5573 6.53701 2.41349 6.81925C2.25 7.14012 2.25 7.56016 2.25 8.40024ZM12.75 10.8752C12.75 11.0823 12.5821 11.2502 12.375 11.2502C12.1679 11.2502 12 11.0823 12 10.8752C12 10.6681 12.1679 10.5002 12.375 10.5002C12.5821 10.5002 12.75 10.6681 12.75 10.8752Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ProfileSVG;
